import gql from "graphql-tag";
export const deleteRecordMutation = gql`
  mutation DeleteRecords($authToken: String, $appId: String!, $recordIds: [String]) {
    deleteRecords(authToken: $authToken, id: $appId, recordIds: $recordIds) {
      recordIds
    }
  }
`;
